<template>
  <b-form-group
    label="Banka"
    label-for="title"
  >
    <v-select
      v-model="dataItem.id_bank_accounts"
      :options="bankAccounts"
      label="title"
      :reduce="item => item.id"
      placeholder="Seçiniz"
    >
      <template v-slot:option="option">
        <div class="font-weight-bold">
          {{ option.title }}
        </div>
        <div class="font-small-2 text-muted">
          {{ option.bank }}
        </div>
      </template>
    </v-select>
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'BankAccounts',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/transferDataItem']
    },
    bankAccounts() {
      return this.$store.getters['bankAccounts/dataList']
    },
  },
  created() {
    this.getBankAccounts()
  },
  methods: {
    getBankAccounts() {
      this.$store.dispatch('bankAccounts/getDataList', {
        select: [
          'bank_accounts.id AS id',
          'bank_accounts.title AS title',
          'banks.title AS bank',
        ],
      })
    },
  },
}
</script>
